import Message from '@/components/#pages/messages/Messages' //Mensajes de usuarios
import Conversations from '@/components/#pages/messages/Conversations' //Mensajes de usuarios
import ConversationRead from '@/components/#pages/messages/ConversationRead' //Mensaje a leer


export default [
    {
        path: '/perfil',
        component: () => import('@/views/Perfil.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/',
                name: 'perfil',
                component: () => import('@/views/perfil/MiPerfil.vue')
            },
            {
                path: 'home',
                name: 'perfil-home',
                component: () => import('@/views/perfil/Home.vue')
            },
            {
                path: 'cv',
                name: 'mi-cv',
                component: () => import('@/views/perfil/MiPerfil.vue')
            },
            {
                path: 'mi-cv',
                name: 'perfil-mi-cv',
                component: () => import('@/views/perfil/MiCV.vue')
            },
            {
                path: 'mensajes',
                component: Message,
                children: [
                    {
                        path: '/',
                        component: Conversations
                    },
                    {
                        path: ':id?',
                        component: ConversationRead
                    }
                ]
            },
            {
                path: 'postulaciones',
                name: 'perfil-postulaciones',
                component: () => import('@/views/perfil/Postulaciones.vue')
            },
            {
                path: 'clases',
                name: 'perfil-clases',
                component: () => import('@/views/perfil/Clases.vue')
            },
            {
                path: 'preferencias-empleo',
                name: 'perfil-preferencias-empleo',
                component: () => import('@/views/perfil/PreferenciasEmpleo.vue')
            },
            {
                path: 'preferencias-curso',
                name: 'perfil.preferencias-curso',
                component: () => import('@/views/perfil/PrefereciasCurso.vue')
            },
            {
                path: 'favoritos',
                name: 'perfil-favoritos',
                component: () => import('@/views/perfil/Favoritos.vue')
            },
            {
                path: 'cursos',
                name: 'perfil-cursos',
                component: () => import('@/views/perfil/Cursos.vue')
            },
            {
                path: 'interesados',
                name: 'perfil-interesado',
                component: () => import('@/views/perfil/Interesados.vue')
            },
            {
                path: 'candidatos',
                name: 'perfil-candidatos',
                component: () => import('@/views/perfil/Candidatos.vue')
            },
            {
                path: 'cuenta-kllaar',
                name: 'cuenta-kllaar',
                component: () => import('@/views/perfil/CuentaKllaar.vue')
            },
            {
                path: 'empleos',
                name: 'perfil-empleos',
                component: () => import('@/views/perfil/Empleos.vue')
            },
            {
                path: 'flyer',
                name: 'perfil-flyer',
                component: () => import('@/views/perfil/Flyer.vue')
            },
            {
                path: 'empleados',
                name: 'perfil-empleados',
                component: () => import('@/views/perfil/Empleados.vue')
            },
            {
                path: 'buscar-candidatos',
                name: 'buscar-candidatos',
                component: () => import('@/views/perfil/BuscarCandidatos.vue')
            },
            {
                path: 'membresia',
                name: 'perfil-membresia',
                component: () => import('@/views/perfil/Membresia.vue')
            },
            {
                path: 'facturacion',
                name: 'perfil-facturacion',
                component: () => import('@/views/perfil/Facturacion.vue')
            },
            {
                path: 'resenas',
                name: 'perfil-reseñas',
                component: () => import('@/views/perfil/Evaluacion.vue')
            },
            {
                path: 'metodos-pago',
                name: 'perfil-metodos-pago',
                component: () => import('@/views/perfil/MetodosPago.vue')
            },
            {
                path: 'eliminar-cuenta',
                name: 'eliminar-cuenta',
                component: () => import('@/views/perfil/Preferencias.vue')
            },

        ]
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/perfil.js